/* eslint-disable no-unused-vars */
import axios from "axios";
import { supabase } from "../supabaseClient";

async function getLeadTokens(leadId) {
	const { data, error, count } = await supabase
		.from("EventTokenLeadRelations")
		.select(
			"amount,created_at,isRefunded, last_updated_at, leadId, paidAmount,paymentId, qrUrl, tokenNumber, status,isPrerequisiteUsed,linkedTokenId(paymentId), eventTokenId(*,tokenId(*,inventoryTypeId(*))),eventId(*,EventOnlineBookingConfig:EventOnlineBookingConfig!eventId(*)),TokenTransactions!left(*) ",
			{ count: "exact" }
		)
		.eq("leadId", leadId)
		.order("last_updated_at", { ascending: false });
	if (data) return { data, count };
	else throw error;
}

async function refundTokenPayment(body) {
	return new Promise((resolve, reject) => {
		// process.env.REACT_APP_PAYMENT_LINK_URL
		// 'http://192.168.2.113:8000/'
		axios
			.post(process.env.REACT_APP_PAYMENT_LINK_URL + "payments/refund", body)
			.then((resp) => {
				resolve(resp);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

async function getLeadTokensById(paymentId) {
	const { data, error, count } = await supabase
		.from("EventTokenLeadRelations")
		.select(
			"amount,created_at,isRefunded, last_updated_at, leadId, paidAmount,paymentId, qrUrl, tokenNumber, status, eventTokenId(*,tokenId(*,inventoryTypeId(*))), eventId(*),TokenTransactions!left(*) ",
			{ count: "exact" }
		)
		.eq("paymentId", paymentId);
	if (data) return { data, count };
	else throw error;
}
async function getPriorityPassTokens(tokenIds) {
	const { data, error, count } = await supabase
		.from("EventTokens")
		.select("*, eventId(*),tokenId(*,inventoryTypeId(*))", { count: "exact" })
		.in("prerequisiteId", tokenIds)
		// .gte('startPaymentFrom', new Date().getTime()).lt('expirePaymentOn', new Date().getTime())
		.order("last_updated_at", { ascending: false });
	if (data) return { data, count };
	else throw error;
}
async function assignNewToken(tokenObj) {
	const { data, error } = await supabase.from("EventTokenLeadRelations").insert([tokenObj]);
	if (data) return data;
	else throw error;
}
async function getTokenPaymentLink(paymentLinkId) {
	return new Promise((resolve, reject) => {
		axios
			.post(process.env.REACT_APP_PAYMENT_LINK_URL + "payments/get-payment-link", { linkId: paymentLinkId })
			.then((resp) => {
				resolve(resp);
			})
			.catch((err) => {
				reject(err);
			});
	});
}
async function tokenRefundRequest(loggedInUserId, paymentId, reason, status) {
	const { data, error } = await supabase.from("TokenRefundRequests").insert([
		{
			userId: loggedInUserId,
			lastUpdatedBy: loggedInUserId,
			paymentId: paymentId,
			reason: reason,
			status: status,
		},
	]);
	if (data) return data;
	else throw error;
}
async function updateLeadAllStatus(leadId, status) {
	const { data, error } = await supabase.from("LeadStatus").update({ status: status, last_updated_at: Date.now() }).eq("leadId", leadId).single();
	if (data) return data;
	else throw error;
}
async function updateLeadTokenStatus(leadId, status, paymentId) {
	const { data, error } = await supabase.from("EventTokenLeadRelations").update({ status: status }).eq("leadId", leadId).eq("paymentId", paymentId);
	if (data) return data;
	else throw error;
}
async function getTokenRefundRequest(tokenId) {
	const { data, error } = await supabase.from("TokenRefundRequests").select("*").eq("paymentId", tokenId);
	if (data) return data;
	else throw error;
}
async function getPreselectPaymentConfig(eventId) {
	const { data, error } = await supabase.from("Events").select("preselectPaymentModes").eq("eventId", eventId);
	if (data) return data;
	else throw error;
}
async function getPrerequisiteToken(tokenId) {
	const { data, error } = await supabase.from("EventTokenLeadRelations").select("*").eq("linkedTokenId", tokenId);
	if (data) return data;
	else throw error;
}
async function revertLeadStatus(token) {
	return new Promise((resolve, reject) => {
		supabase
			.from("LeadStatus")
			.update({ status: "Token Payment Complete", last_updated_at: Date.now() })
			.eq("leadId", token.leadId)
			.then(async (_r) => {
				let obj = {
					leadId: token.leadId,
					leadStatus: "Token Payment Complete",
					message: token.eventTokenId.tokenId.name + "(" + token.eventTokenId.tokenId.shortCode + ") payment expired",
				};
				await addLeadLogs(obj)
					.then((leadLog) => {
						console.log(leadLog);
					})
					.catch((err) => {
						console.log("leadlog", err);
					});
				resolve(true);
			})
			.catch((err) => {
				console.log("err: ", err);
				reject(err);
			});
	});
}
async function addLeadLogs(obj) {
	const { data, error } = await supabase.from("LeadLogs").insert([
		{
			...obj,
		},
	]);
	if (data) return data;
	else throw error;
}
async function checkIfLimitCrossed(eventTokenId) {
	return new Promise((resolve, reject) => {
		const responseObj = { allow: false };
		supabase
			.from("EventTokens")
			.select("limit")
			.eq("eventTokenId", eventTokenId)
			.then((etResp) => {
				console.log("etResp: ", etResp);
				supabase
					.from("EventTokenLeadRelations")
					.select("*", { count: "exact" })
					.eq("eventTokenId", eventTokenId)
					.then((etlrResp) => {
						console.log("etlrResp: ", etlrResp);
						if (etlrResp.count < etResp.data[0].limit) {
							responseObj.allow = true;
						}
						resolve(responseObj);
					})
					.catch((err) => {
						console.log("error in getting leads with priority pass token: ", eventTokenId, err);
						reject(responseObj);
					});
			})
			.catch((err) => {
				console.log("error in getting limit of priority pass token: ", eventTokenId, err);
				reject(responseObj);
			});
	});
}

async function getTokenServerTime() {
	return new Promise((resolve, reject) => {
		axios
			.get(process.env.REACT_APP_STANDARD_TIME_URL)
			.then((resp) => {
				resolve(resp);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

async function getPreselectTokenData(paymentId) {
	const { data, error } = await supabase
		.from("AllotmentPayment")
		.select("*,unitId(*,projectId(*),wingId(*),inventoryTypeId(*)),inventoryMergedId(*,unit1Id(*,projectId(*),wingId(*)),unit2Id(*))")
		.eq("paymentId", paymentId);
	if (data) return data;
	else throw error;
}
async function createTokenPaymentLink(amt, type, selectedToken) {
	return new Promise((resolve, reject) => {
		axios
			.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}payments/create-payment-link-new`, {
				mode: type,
				amount: amt,
				leadName: JSON.parse(localStorage.getItem("selectedLead")).personId.name,
				leadEmail: JSON.parse(localStorage.getItem("selectedLead")).personId.email,
				leadContactNumber: JSON.parse(localStorage.getItem("selectedLead")).personId.contactNumber,
				tokenName: selectedToken.eventTokenId.tokenId.name,
				eventName: selectedToken.eventId.title,
				paymentId: selectedToken.paymentId,
				leadId: selectedToken.leadId,
				eventTokenId: selectedToken.eventTokenId.eventTokenId,
				expiry: selectedToken.eventTokenId.tokenId.isPriorityPass
					? selectedToken.created_at + selectedToken.eventTokenId.paymentTimer * 60000
					: selectedToken.paidAmount === 0
					? selectedToken.created_at + 86400000
					: null,
				allotmentPaymentId: selectedToken?.allotmentPaymentId?.allotmentPaymentId,
				unitId: selectedToken?.allotmentPaymentId?.unitId?.unitId,
				inventoryMergeId: selectedToken?.allotmentPaymentId?.inventoryMergedId?.inventoryMergeId,
			})
			.then((response) => {
				resolve(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

async function tokenPaymentTransactions(id, amt, selectedToken) {
	return new Promise((resolve, reject) => {
		supabase
			.from("Transactions")
			.insert({
				orderId: id,
				amount: amt,
				modeOfPayment: "Razorpay-Customer Portal",
				// leadId: selectedToken.leadId,
				status: "pending",
			})
			.select()
			.then((transactionData) => {
				if (transactionData.data) {
					supabase
						.from("LeadTransactionRelations")
						.insert({ leadId: selectedToken?.leadId, transactionId: transactionData.data[0].id })
						.then((resp) => {
							if (resp.data) {
								supabase
									.from("TokenTransactions")
									.insert({
										orderId: id,
										amount: amt,
										eventTokenId: selectedToken.eventTokenId.eventTokenId,
										paymentId: selectedToken.paymentId,
										leadId: selectedToken.leadId,
										status: "pending",
									})
									.then((resToken) => {
										if (resToken.data) {
											resolve({ success: true });
										} else {
											reject({ success: false });
										}
									})
									.catch((err) => {
										reject(err);
									});
							} else {
								reject({ success: false });
							}
						})
						.catch((err) => {
							reject(err);
						});
				} else {
					reject({ success: false });
				}
			})
			.catch((err) => {
				reject(err);
			});
	});
}

async function eventTokenPaymentLink(amt, selectedToken) {
	return new Promise((resolve, reject) => {
		axios
			.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}payments/create-payment-link-new`, {
				mode: "token",
				amount: amt,
				leadName: JSON.parse(localStorage.getItem("selectedLead")).personId.name,
				leadEmail: JSON.parse(localStorage.getItem("selectedLead")).personId.email,
				leadContactNumber: JSON.parse(localStorage.getItem("selectedLead")).personId.contactNumber,
				tokenName: selectedToken.eventTokenId.tokenId.name,
				eventName: selectedToken.eventId.title,
				paymentId: selectedToken.paymentId,
				leadId: selectedToken.leadId,
				eventTokenId: selectedToken.eventTokenId.eventTokenId,
				expiry: selectedToken.eventTokenId.tokenId.isPriorityPass
					? selectedToken.created_at + selectedToken.eventTokenId.paymentTimer * 60000
					: selectedToken.paidAmount === 0
					? selectedToken.created_at + 86400000
					: null,
			})
			.then((response) => {
				resolve(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

async function priorityPassToken(ppObj) {
	return new Promise((resolve, reject) => {
		axios
			.post(process.env.REACT_APP_PAYMENT_LINK_URL + "scheduler/assignPP", ppObj)
			.then((response) => {
				resolve(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

export {
	getLeadTokens,
	getTokenPaymentLink,
	updateLeadAllStatus,
	updateLeadTokenStatus,
	tokenRefundRequest,
	getTokenRefundRequest,
	getPreselectPaymentConfig,
	getPriorityPassTokens,
	assignNewToken,
	getLeadTokensById,
	getPrerequisiteToken,
	revertLeadStatus,
	checkIfLimitCrossed,
	refundTokenPayment,
	getTokenServerTime,
	getPreselectTokenData,
	createTokenPaymentLink,
	tokenPaymentTransactions,
	eventTokenPaymentLink,
	priorityPassToken,
};
